import { useEffect, useState } from 'react';
import { listPhotos, type Photo } from '../api/photos';

type Props = {
  tripId: string;
  /** ids già selezionati (per stato iniziale) */
  initialSelected: string[];
  onCancel: () => void;
  onConfirm: (selected: string[]) => void;
};

export function PhotoSelector({ tripId, initialSelected, onCancel, onConfirm }: Props) {
  const [photos, setPhotos] = useState<Photo[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [selected, setSelected] = useState<Set<string>>(() => new Set(initialSelected));

  useEffect(() => {
    listPhotos(tripId)
      .then(setPhotos)
      .catch((e: Error) => setError(e.message ?? 'Errore caricamento'));
  }, [tripId]);

  function toggle(id: string) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3>Seleziona foto</h3>
          <span className="muted">{selected.size} selezionate</span>
        </div>

        {error && <p className="err">{error}</p>}
        {!photos && !error && <p className="muted">Caricamento…</p>}

        {photos && photos.length === 0 && (
          <p className="muted">
            Non hai ancora caricato foto in questo viaggio. Caricane qualcuna dalla galleria.
          </p>
        )}

        {photos && photos.length > 0 && (
          <ul className="select-grid">
            {photos.map((p) => {
              const isSel = selected.has(p.id);
              return (
                <li
                  key={p.id}
                  className={`select-thumb${isSel ? ' selected' : ''}`}
                  onClick={() => toggle(p.id)}
                >
                  <img src={p.url} alt={p.caption ?? ''} loading="lazy" />
                  <span className="select-mark" aria-hidden>
                    {isSel ? '✓' : ''}
                  </span>
                </li>
              );
            })}
          </ul>
        )}

        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onCancel}>
            Annulla
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => onConfirm(Array.from(selected))}
          >
            Conferma ({selected.size})
          </button>
        </div>
      </div>
    </div>
  );
}
